(() => {
  if (window.__eyeseeFormPattern) return;
  window.__eyeseeFormPattern = true;

  // Last-resort release when a submit never navigates, such as a failed or abandoned
  // captcha challenge or dropped connection. Delay is long enough for a slow genuine post.
  const RELEASE_LOCK_AFTER_MS = 15000;

  const releaseInFlightState = (form) => {
    if (form.__eyeseeFormReleaseTimer) {
      clearTimeout(form.__eyeseeFormReleaseTimer);
      delete form.__eyeseeFormReleaseTimer;
    }
    form.removeAttribute('aria-busy');
    const submit = form.querySelector('.form__submit');
    if (!submit) return;
    submit.disabled = false;
    if (submit.dataset.originalText !== undefined) {
      submit.textContent = submit.dataset.originalText;
      delete submit.dataset.originalText;
    }
  };

  const clearInFlightState = () => {
    document.querySelectorAll('form[data-form][aria-busy="true"]').forEach((form) => {
      releaseInFlightState(form);
    });
  };

  const engageInFlightState = (form) => {
    if (form.getAttribute('aria-busy') === 'true') return;
    const submit = form.querySelector('.form__submit');
    if (!submit) return;

    form.setAttribute('aria-busy', 'true');
    submit.dataset.originalText = submit.textContent;
    const submittingLabel = form.dataset.submittingLabel;
    if (submittingLabel) submit.textContent = submittingLabel;
    submit.disabled = true;
    form.__eyeseeFormReleaseTimer = setTimeout(() => {
      releaseInFlightState(form);
    }, RELEASE_LOCK_AFTER_MS);
  };

  const focusStatus = () => {
    const status = document.querySelector('.form__status--error[data-form-status]')
      || document.querySelector('[data-form-status]');
    if (!status || document.activeElement !== document.body) return;
    try {
      status.focus();
    } catch (_error) {
      // Focus fallback is best-effort for browsers that ignore autofocus on status regions.
    }
  };

  document.addEventListener('submit', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const form = target.closest('form[data-form]');
    if (!form) return;
    if (form.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    if (!form.checkValidity()) return;
    if (event.defaultPrevented) return;

    // Disabling synchronously inside a submit handler cancels submission in some engines.
    setTimeout(() => {
      if (event.defaultPrevented) return;
      engageInFlightState(form);
    }, 0);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) clearInFlightState();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusStatus, { once: true });
  } else {
    focusStatus();
  }
})();
